module.exports = __webpack_public_path__ + "assets/images/KYD25.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/KYD25.png
// module id = 1414
// module chunks = 1